import { QueryClient } from '@tanstack/react-query'

export const customerAccountQueryKey = ['customer-account'] as const
export const customerStationsQueryKey = ['customer-stations'] as const
export const customerReportsQueryKey = ['customer-reports'] as const

export function clearCustomerSessionCache(queryClient: QueryClient) {
  queryClient.removeQueries({ queryKey: customerAccountQueryKey })
  queryClient.removeQueries({ queryKey: customerStationsQueryKey })
  queryClient.removeQueries({ queryKey: customerReportsQueryKey })
}
